<app-page-wrapper
  title="Payment Details"
  [subtitle]="'Reference #' + (payment?.reference_number || 'N/A')"
  [goBackUrl]="'/payments'">
  @if (isLoading) {
    <app-loading-spinner message="Loading payment details..."></app-loading-spinner>
  } @else if (payment) {
    <div class="container-fluid">
      <div class="row g-4">
        <!-- Main Details -->
        <div class="col-lg-8 p-3 pe-0">
          <div class="card shadow-sm mb-4">
            <div class="card-body p-4">
              <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Transaction Information</h6>
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="small text-muted mb-1">Date</label>
                  <div class="fw-bold">{{ payment.date | date: 'mediumDate' }}</div>
                </div>
                <div class="col-md-6">
                  <label class="small text-muted mb-1">Reference Number</label>
                  <div class="fw-bold">{{ payment.reference_number || '-' }}</div>
                </div>
                <div class="col-md-6">
                  <label class="small text-muted mb-1">Amount</label>
                  <div class="fw-bold text-success">{{ payment.received_amount | currency: 'INR' }}</div>
                </div>
                <div class="col-md-6">
                  <label class="small text-muted mb-1">Payment Type</label>
                  <div class="fw-bold text-capitalize">{{ payment.payment_type.toUpperCase() }}</div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow-sm mb-4">
            <div class="card-body p-4">
              <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Additional Information</h6>
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="small text-muted mb-1">Bank Name</label>
                  <div class="fw-bold">{{ payment.bank_name || '-' }}</div>
                </div>
                <div class="col-md-4">
                  <label class="small text-muted mb-1">Cheque Date</label>
                  <div class="fw-bold">
                    {{ payment.cheque_date ? (payment.cheque_date | date: 'mediumDate') : '-' }}
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="small text-muted mb-1">Created At</label>
                  <div class="fw-bold">{{ payment.created_at | date: 'short' }}</div>
                </div>
                @if (payment.company) {
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Billing Firm</label>
                    <div class="fw-bold">{{ payment.company.name || '-' }}</div>
                  </div>
                  <div class="col-md-6">
                    <label class="small text-muted mb-1">Address</label>
                    <div class="fw-bold">{{ payment.company.address || '-' }}</div>
                  </div>
                }
                <div class="col-12" *ngIf="payment.remarks">
                  <label class="small text-muted mb-1">Remarks</label>
                  <p class="mb-0 small bg-light p-3 text-muted">
                    {{ payment.remarks }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Sidebar Info -->
        <div class="col-lg-4 p-3">
          <!-- Dealer Card -->
          <div class="card shadow-sm mb-4">
            <div class="card-body p-4">
              <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Dealer Details</h6>
              @if (payment.dealer) {
                <div class="d-flex align-items-center mb-3">
                  <div class="bg-primary bg-opacity-10 p-3 rounded-circle text-primary me-3">
                    <i class="bi bi-person fs-4"></i>
                  </div>
                  <div>
                    <div class="fw-bold text-dark">
                      {{ payment.dealer.shop_name }}
                    </div>
                    <div class="text-muted small">{{ payment.dealer.first_name }} {{ payment.dealer.last_name }}</div>
                  </div>
                </div>
                <div class="p-3 bg-light small">
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">Phone:</span>
                    <span class="fw-bold">{{ payment.dealer.phone_number }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">Email:</span>
                    <span class="fw-bold">{{ payment.dealer.email || '-' }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">Address:</span>
                    <span class="fw-bold">{{ payment.dealer.address_line_1 || '-' }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">District:</span>
                    <span class="fw-bold">{{ payment.dealer.district || '-' }}</span>
                  </div>
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">State:</span>
                    <span class="fw-bold">{{ payment.dealer.state || '-' }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="text-muted">Pincode:</span>
                    <span class="fw-bold">{{ payment.dealer.pincode || '-' }}</span>
                  </div>
                </div>
              } @else {
                <div class="text-center py-4 bg-light border border-dashed">
                  <p class="text-muted small mb-0">No dealer associated</p>
                </div>
              }
            </div>
          </div>

          <!-- Collected By Card -->
          @if (payment.employee) {
            <div class="card shadow-sm mb-4">
              <div class="card-body p-4">
                <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Collected By</h6>
                <div class="d-flex align-items-center mb-3">
                  @if (payment.employee.profile_picture) {
                    <img
                      [src]="payment.employee.profile_picture"
                      class="rounded-circle me-3 object-fit-cover"
                      width="48"
                      height="48"
                      alt="Employee" />
                  } @else {
                    <div class="bg-secondary bg-opacity-10 p-3 rounded-circle text-secondary me-3">
                      <i class="bi bi-person fs-4"></i>
                    </div>
                  }
                  <div>
                    <div class="fw-bold text-dark">{{ payment.employee.full_name }}</div>
                    <div class="text-muted small">
                      {{ payment.employee.employee?.designation?.title || payment.employee.role }}
                    </div>
                  </div>
                </div>
                <div class="p-3 bg-light small">
                  <div class="d-flex justify-content-between mb-2">
                    <span class="text-muted">Phone:</span>
                    <span class="fw-bold">{{ payment.employee.phone_number || '-' }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <span class="text-muted">Email:</span>
                    <span class="fw-bold">{{ payment.employee.email || '-' }}</span>
                  </div>
                </div>
              </div>
            </div>
          }

          <!-- Proof Card -->
          <div class="card shadow-sm" *ngIf="payment.proof">
            <div class="card-body p-4">
              <h6 class="text-uppercase fw-bold text-muted small mb-3 letter-spacing-1">Payment Proof</h6>
              <div class="d-grid">
                <a [href]="payment.proof" target="_blank" class="btn btn-soft-primary">
                  <i class="bi bi-file-earmark-image me-2"></i>
                  View Proof
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else {
    <app-error-alert [error]="'Payment not found or details failed to load.'" />
  }
</app-page-wrapper>
